import {isAnyOf, Middleware} from '@reduxjs/toolkit'
import {Span} from '@sentry/types'

import {startOrder} from '@web/features/orderProcessor'
import {Sentry} from '@web/helpers/log'
import {getChannelType, getPathNameInfo, getOrderSheetId} from '@web/helpers/path'
import {isLocationChangeAction} from '@web/helpers/redux'

import {redirectToOrderResult} from '../../actions/order2'

const ORDER_PROCESS_TRANSACTION_NAME = 'orderProcessTransaction'

let orderProcessTransaction: Span | null = null

// transaction 을 시작하는 액션인지 검사
const isStart = isAnyOf(startOrder.pending)

// transaction을 종료하는 액션인지 검사
const isFinish = isAnyOf(redirectToOrderResult.fulfilled)

/** C1주문서의 Sentry 관련 액션에 대한 사이드이펙트 관리  */
const sentryTransaction: Middleware =
    ({getState}) =>
    (next) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action: any) => {
        if (isStart(action)) {
            orderProcessTransaction = Sentry.startTransaction({name: ORDER_PROCESS_TRANSACTION_NAME})
        }

        if (isFinish(action)) {
            orderProcessTransaction?.setStatus({code: 1}).end()
        }

        next(action)

        const nextState = getState()
        const naverIdNo = nextState.purchaser.naverIdNo

        // C1 주문서 페이지 진입 시 orderSheetId, saleChannel 을 추출하여 태그에 기록
        // 재진입시에도 동작하겠으나, 동일한 값이므로 중복 기록되어도 문제 없음
        /** @TODO 성룡님 확인 필요 */
        if (isLocationChangeAction(action) && getPathNameInfo(window.location.pathname).isOrderSheetPathname()) {
            Sentry.setTags({
                ...(naverIdNo ? {nidno: naverIdNo} : {}),
                orderSheetId: getOrderSheetId(),
                channel: getChannelType(),
            })
        }
    }

export default sentryTransaction
